<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div
            class="flex-card light-bordered light-raised has-margin-top-30"
            style="overflow: auto"
          >
            <div class="card-body">
              <ValidationObserver v-slot="{ passes }">
                <div class="has-text-centered has-margin-bottom-30">
                  <h2 class="title">Edit Profile</h2>
                </div>
                <form @submit.prevent="passes(submit)">
                  <div class="columns is-multiline">
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseInput
                          label="Firstname"
                          v-model="entry.firstname"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseInput
                          label="Surname"
                          v-model="entry.surname"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseDatePicker
                          label="Date of Birth"
                          rules="required"
                          v-model="entry.dob"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <GenderSelect
                          label="Gender"
                          v-model="entry.gender"
                          rules="required"
                        />
                      </div>
                    </div>

                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseInput
                          label="Email Address"
                          v-model="entry.email"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseInput
                          label="Mobile No"
                          v-model="entry.contactno"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseInput
                          label="Gym Name"
                          v-model="entry.gymname"
                          rules="required"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <CountrySelect v-model="entry.country" />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseInput
                          label="Default Emergency Contact Name"
                          v-model="entry.emergencycontactname"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <BaseInput
                          label="Default Emergency Contact Number"
                          v-model="entry.emergencycontactno"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <SizeSelect
                          label="Shirt Size"
                          v-model="entry.tshirtsize"
                        />
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <SizeSelect
                          label="Pants Size"
                          v-model="entry.pantssize"
                        />
                      </div>
                    </div>
                    <div class="column is-12-desktop">
                      <div class="control">
                        <b-checkbox v-model="entry.marketingoptin">
                          Opt-in for events newsletter and marketing
                        </b-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="has-text-centered has-margin-top-30">
                    <div class="is-block has-text-centered">
                      <button
                        class="button is-medium btn-align no-lh raised primary-btn"
                        type="submit"
                        :disabled="saving"
                        :class="{ 'is-loading': saving }"
                      >
                        Update</button
                      ><br /><br />
                      <router-link
                        class="button btn-align no-lh raised has-margin-right-5-desktop"
                        :to="{ name: 'ManageDependants' }"
                      >
                        Manage Dependants
                      </router-link>
                      <a
                        class="button btn-align no-lh raised has-margin-right-5-desktop has-margin-top-10-mobile"
                        :href="`/athlete/${entry._id}`"
                        target="_blank"
                      >
                        View Public Profile
                      </a>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BaseInput from "@/components/BaseInput";
import BaseDatePicker from "@/components/BaseDatePicker";
import GenderSelect from "@/components/GenderSelect";
import CountrySelect from "@/components/CountrySelect";
import SizeSelect from "@/components/SizeSelect";
import UserApi from "@/api/user";
export default {
  components: {
    BaseInput,
    GenderSelect,
    BaseDatePicker,
    CountrySelect,
    SizeSelect,
  },
  data() {
    return {
      entry: {},
      saving: false,
      loading: true,
    };
  },
  created() {
    this.getFullUser().then((user) => {
      this.entry = user;
      this.loading = false;
    });
  },
  methods: {
    ...mapActions(["getFullUser"]),
    async submit() {
      this.saving = true;
      try {
        await UserApi.updateUser(this.entry);
        this.$buefy.toast.open({
          message: "Profile updated successfully!",
          position: "is-top",
          type: "is-success",
        });
        this.saving = false;
      } catch (error) {
        console.log(error);
        this.saving = false;
        this.$buefy.toast.open({
          message: "Error updating your profile.",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
  },
};
</script>